import React, { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";
import { PageHeader } from "@/components/Common";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";

export default function Settings() {
    const { user, logout } = useAuth();
    const [current, setCurrent] = useState("");
    const [next, setNext] = useState("");
    const [busy, setBusy] = useState(false);

    const change = async () => {
        if (next.length < 6) return toast.error("New password must be at least 6 chars");
        setBusy(true);
        try {
            await api.post("/auth/change-password", { current_password: current, new_password: next });
            toast.success("Password changed — please sign in again");
            setCurrent("");
            setNext("");
            setTimeout(logout, 1200);
        } catch (e) {
            toast.error(e.response?.data?.detail || "Change failed");
        } finally {
            setBusy(false);
        }
    };

    return (
        <>
            <PageHeader title="Settings" subtitle="Account, security, environment." />
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <Card>
                    <CardHeader className="pb-2">
                        <CardTitle className="text-base">Account</CardTitle>
                    </CardHeader>
                    <CardContent className="space-y-2 text-sm">
                        <div className="flex justify-between"><span className="text-muted-foreground">Name</span><span className="font-medium">{user?.name}</span></div>
                        <div className="flex justify-between"><span className="text-muted-foreground">Email</span><span className="font-medium">{user?.email}</span></div>
                        <div className="flex justify-between"><span className="text-muted-foreground">Role</span><span className="font-medium capitalize">{user?.role?.replace("_", " ")}</span></div>
                        <div className="flex justify-between"><span className="text-muted-foreground">Active</span><span className="font-medium">{user?.active ? "Yes" : "No"}</span></div>
                    </CardContent>
                </Card>
                <Card>
                    <CardHeader className="pb-2">
                        <CardTitle className="text-base flex items-center gap-2"><ShieldCheck className="w-4 h-4" /> Change password</CardTitle>
                    </CardHeader>
                    <CardContent className="space-y-3">
                        <div>
                            <Label>Current password</Label>
                            <Input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} data-testid="settings-cur-pwd" />
                        </div>
                        <div>
                            <Label>New password</Label>
                            <Input type="password" value={next} onChange={(e) => setNext(e.target.value)} data-testid="settings-new-pwd" />
                        </div>
                        <Button onClick={change} disabled={busy} data-testid="settings-change-pwd">{busy ? "Saving…" : "Change password"}</Button>
                    </CardContent>
                </Card>
            </div>
        </>
    );
}
